import { useGlobalLoader } from "@/components/GlobalLoader";
import inovaone_api from "@/services/inovaone_api";
import type { ImpressaoItem } from "@/types/impressao-item";
import { createContext, useContext, type ReactNode } from "react";
import { useImpressaoConfig } from "../ImpressaoConfigContext";
import { useItem } from "../ItemContext";

export type VerificarImpressaoContextType = {
  verificarImpressao: (itens: ImpressaoItem[]) => Promise<void>;
};

export const VerificarImpressaoContext = createContext<
  VerificarImpressaoContextType | undefined
>(undefined);

export function VerificarImpressaoProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { impressaoConfig } = useImpressaoConfig();
  const { setIsLoading } = useGlobalLoader();
  const { salvarItensNaBase } = useItem();
  const verificarImpressao = async (itens: ImpressaoItem[]) => {
    setIsLoading(true);
    try {
      const tags = itens.map((item) => item.tag);
      const response_tags = await inovaone_api.post<ImpressaoItem[]>(
        `/pesquisar-itens/${impressaoConfig?.id_conta}`,
        [{ tags }]
      );

      const tags_nao_encontradas: ImpressaoItem[] = itens.filter(
        (item) =>
          !response_tags.data.some((itemNaBase) => itemNaBase.tag === item.tag)
      );
      if (tags_nao_encontradas.length > 0) {
        await salvarItensNaBase(tags_nao_encontradas);
      }
    } catch (error) {
      console.error("Erro ao verificar impressão:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <VerificarImpressaoContext.Provider value={{ verificarImpressao }}>
      {children}
    </VerificarImpressaoContext.Provider>
  );
}

export function useVerificarImpressao() {
  const context = useContext(VerificarImpressaoContext);
  if (!context) {
    throw new Error(
      "useVerificarImpressao deve ser usado dentro de um VerificarImpressaoProvider"
    );
  }
  return context;
}
